/** DashboardRoute — skin-aware switcher for /. */
import { useUISkin } from "@/data/UISkinContext";
import Dashboard from "./Dashboard";
import { CockpitFrame } from "@/components/cockpit/CockpitFrame";

export default function DashboardRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") {
    return (
      <CockpitFrame 
        // eyebrow="Workspace · Overview" 
        title="Dashboard">
        <Dashboard />
      </CockpitFrame>
    );
  }
  return <Dashboard />;
}
